module.exports = __webpack_public_path__ + "static/cheques-and-banking-2e05663139a736042b01c9933b95aa56.jpg";